import "core-js/modules/es.array.push.js";
import axios from 'axios';
import { message } from 'ant-design-vue';
import qs from 'qs';
import store from '@/store';
import { cryptoEncrypt, cryptoDecrypt } from './aes';
import { setCache, removeCache } from '@/utils/session';
import router from '@/router';
let urls = 'admin/order/download,admin/policy/export,admin/policy/personnel-details-record/export,admin/order/order-payment-download,admin/company/workers/zip,upload/stream,admin/claims/zip,admin/audit/claims-review/zip,admin/policy/zip,admin/claims/record-export,admin/policy/export-zip,admin/customer-insurance/generate_qr_code,admin/policy/personnel-details/export,admin/policy/personnel-details-record/endorsement-export,admin/policy/correct-record/personnel-export,admin/policy/correct-record/export,admin/v2/group-insurance/correct-record-export,admin/insured-blacklist/export,admin/user/insurance-notice/download';
let urls2 = 'admin/contract/store,admin/contract/edit,admin/company/workers/base-store,admin/company/workers/base-edit,admin/company/workers/certificate-edit,admin/audit/claims/store,admin/claims/store';
//url3为需要返回整个response的接口
let urls3 = 'admin/policy/personnel-details/export,admin/policy/personnel-details-record/endorsement-export';

//生产测试都需要返回data
let urlResponseAll = 'admin/policy/correct/batch-sort,admin/v2/group-insurance/batch-sort';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000 // 请求超时时间
});

//请求
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = 'bearer ' + store.getters.token;
  }
  if (config.url != 'admin/policy/resource') {
    config.headers['X-Dispatch'] = 'Admin';
    config.headers['X-Version'] = 'customer';
  }
  if (urls.indexOf(config.url) > -1) {
    config.responseType = 'blob';
  }
  if (process.env.NODE_ENV === 'production') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }
  if (config.url === 'upload/file') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.headers['X-Dispatch'] = 'Upload';
    config.headers['X-Version'] = 'upload';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
  }
  return config;
});

//响应
service.interceptors.response.use(response => {
  var token = response.headers.authorization;
  if (token) {
    // store.commit('SET_TOKEN', token.split(" ")[1]);
    setCache('TOKEN', token.split(' ')[1]);
    // console.log(store.getters.token)
  }
  const data = response.data;
  if (urls3.indexOf(response.config.url) > -1) {
    return Promise.resolve(response);
  } else if (urls.indexOf(response.config.url) > -1 || urls2.indexOf(response.config.url) > -1 || urlResponseAll.indexOf(response.config.url) > -1) {
    return Promise.resolve(data);
  } else if (data.code === 200) {
    return Promise.resolve(data);
  } else {
    message.destroy();
    message.error(window.vm.$i18n.t(response.data.message) || '');
    console.log(response.data.message);
    if (response.data.code == 500002 || response.data.code == 500003) {
      // store.commit('SET_TOKEN', '');
      // store.commit('SET_USERINFO', '');
      // removeCache('TOKEN');
      store.dispatch('user/logout');
      router.push({
        name: 'login'
      });
    } else {
      return Promise.reject(response);
    }
  }
}, error => {
  if (urls2.indexOf(error.response.config.url) > -1) {
    return Promise.resolve(error.response.data);
  } else {
    message.destroy();
    message.error(window.vm.$i18n.t(error.response.data.message) || '');
    console.log(error.response.data.message);
    return Promise.reject(error.response);
  }

  // console.log(error.response.data)
});
let http = {};

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

http.get = function (url, params = null) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params
    }).then(res => {
      resolve(res.data);
    }).catch(e => {
      reject(e);
    });
  });
};

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

http.post = function (url, paramsObj, type) {
  let params = {
    timestamp: Math.round(new Date().getTime() / 1000).toString(),
    data: paramsObj
  };
  if (process.env.NODE_ENV === 'production') {
    params.data.timestamp = params.timestamp;
    params.data = cryptoEncrypt(JSON.stringify(params.data));
    params = qs.stringify(params);
  } else {
    params.data.timestamp = params.timestamp;
  }
  if (url === 'upload/file') {
    params = paramsObj;
  }
  // else{
  //   params.data = JSON.stringify(params.data)
  // }
  // Object.assign(params.data, paramsObj)
  // params.data = cryptoEncrypt(JSON.stringify(params.data))
  return new Promise((resolve, reject) => {
    service.post(url, params, type).then(res => {
      if (urls.indexOf(url) > -1 || urlResponseAll.indexOf(url) > -1) {
        resolve(res);
      } else if (urls2.indexOf(url) > -1) {
        if (process.env.NODE_ENV === 'production') {
          resolve({
            code: 200,
            data: cryptoDecrypt(res.data)
          });
        } else {
          resolve(res);
        }
        // if (res.code == 200) {
        //   if (process.env.NODE_ENV === 'production') {
        //     resolve({code:200,data:cryptoDecrypt (res.data)});
        //   }else{
        //     resolve(res);
        //   }
        // } else {
        //   message.error(res.message || '');
        // }
      } else {
        if (process.env.NODE_ENV === 'production') {
          resolve(cryptoDecrypt(res.data));
        } else {
          resolve(res.data);
          // params.data = JSON.stringify(params.data)
        }
        // resolve(cryptoDecrypt(res.data));
      }
    }).catch(e => {
      reject(e);
    });
  });
};
export default http;